export default "__VITE_ASSET__b9030c81__"